import CreateAccountManagement from "../../features/AccountManagement/CreateAccountManagement"
import "./AccountManagement.scss"

const AccountManagement = () => {
    return (
        <CreateAccountManagement/>
    )
}

export default AccountManagement